export const SET_MY_INFO = "SET_MY_INFO";
export const CLEAR_MY_INFO = "CLEAR_MY_INFO";
export const CLEAR_USER = "CLEAR_USER";
